<template>
  <div
    class="t-InputColor"
    :class="{ 't-InputColor-error': hasError }"
    @click="handle"
  >
    <input class="t-InputColor-input" :style="color" readonly />
    <div class="t-InputColor-div-icon" name="rightIcons">
      <Icon :handleClick="handle" name="DropDown" class="t-InputColor-icon" />
    </div>
  </div>
</template>

<script>
import Icon from '../Icon/Icon.vue';

export default {
  components: { Icon },
  props: {
    value: String,
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    color() {
      let color = '';
      color += `--track-input-color: ${this.value};`;
      return color;
    },
  },
  methods: {
    handle(event) {
      this.$emit('click', event);
    },
  },
};
</script>
<style scoped>
.t-InputColor {
  width: 68px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--track-color-white);
  border: var(--track-border-sm) solid var(--track-color-bluegray-50);
  border-radius: 2px;
  cursor: pointer;
  margin-right: var(--track-spacing-sm);
}

.t-InputColor-error {
  border-color: var(--track-color-negative-medium);
}

.t-InputColor-input {
  width: 24px;
  height: 24px;
  margin-right: var(--track-spacing-xs);
  background-color: var(--track-input-color);
  border: none;
  padding: 0px;
  border-radius: 2px;
  outline: none;
  cursor: pointer;
}

.t-InputColor-input::-webkit-color-swatch {
  border-color: transparent;
  border-radius: 2px;
}

.t-InputColor-div-icon {
  height: 24px;
}

.t-InputColor-icon {
  fill: var(--track-color-bluegray-70);
}
</style>
